import React from 'react';

import TextInput from '@pray/shared/components/ui/TextInput';
import { formatCurrency } from '@pray/shared/utils';

type CustomDonationInputProps = React.ComponentProps<typeof TextInput> & {
  onChange: (event: React.ChangeEvent<HTMLInputElement>, value: number) => void;
};

export default function CustomDonationInput(props: CustomDonationInputProps) {
  function handleChange(event: React.ChangeEvent<HTMLInputElement>) {
    const { value } = event.target;
    const rawValue = value.replace(/[^0-9]/g, '');

    if (!rawValue || /^\d+$/.test(rawValue)) {
      event.target.value = formatCurrency(parseInt(rawValue || '0', 10) * 100, 0);
      props.onChange?.(event, +rawValue);
    }
  }

  return <TextInput type="tel" maxLength={8} {...props} onChange={handleChange} />;
}
